export const ISSUES_FOR_RE_SIZING_PLYWOOD_REQUEST = "ISSUES_FOR_RE_SIZING_PLYWOOD_REQUEST";
export const ISSUES_FOR_RE_SIZING_PLYWOOD_SUCCESS = "ISSUES_FOR_RE_SIZING_PLYWOOD_SUCCESS";
export const ISSUES_FOR_RE_SIZING_PLYWOOD_FAILED = "ISSUES_FOR_RE_SIZING_PLYWOOD_FAILED";